var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 366,
    height: 309,
    viewBox: "0 0 366 309",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M251.363 272.72V261.95H204.997H204.632V283.581H309.594C315.527 283.581 320.456 278.744 320.456 272.72C320.456 266.787 315.618 261.859 309.594 261.859H264.05V272.72H251.363Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114.638 261.95V272.811H101.951V261.95H56.4063C50.4736 261.95 45.5449 266.787 45.5449 272.811C45.5449 278.744 50.3823 283.673 56.4063 283.673H161.369V261.95H114.638Z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M114.637 261.95H101.95V272.811H114.637V261.95Z",
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M264.049 261.95H251.362V272.811H264.049V261.95Z",
    fill: "#000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M161.368 297.181C161.368 303.387 166.388 308.498 172.686 308.498H193.405C199.611 308.498 204.722 303.478 204.722 297.181V283.49H161.459V297.181H161.368Z",
    fill: "#000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M204.631 261.95H161.368V283.581H204.631V261.95Z",
    fill: "#000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M284.677 21.6312H259.395L140.65 217.5H165.932L214.032 138.185L337.432 205.635C341.813 200.25 344.369 193.405 344.369 185.92V184.825L225.259 119.748L284.677 21.6312Z",
    fill: "#000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6123 217.5H84.7913L127.324 21.6312H105.236L62.6123 217.5Z",
    fill: "#000"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M312.788 0H53.2114C23.8219 0 0 23.9132 0 53.2114V185.829C0 215.219 23.9132 239.041 53.2114 239.041H101.951V228.179H114.637V239.132H161.368V228.271H204.631V239.132H204.996H251.362V228.271H264.049V239.132H312.788C342.178 239.132 366 215.219 366 185.921V53.2114C366.091 23.9132 342.178 0 312.788 0ZM342.087 208.1L337.523 205.635C331.682 212.846 322.828 217.501 312.88 217.501H165.932L153.702 237.763L135.173 226.536L140.65 217.501H84.7915L83.97 221.425H61.791L62.6124 217.501H53.1202C35.6873 217.501 21.5401 203.353 21.5401 185.921V53.2114C21.5401 35.7785 35.6873 21.6314 53.1202 21.6314H105.145L107.974 8.48826L129.15 13.0518L127.324 21.5401H259.394L266.605 9.58353L285.133 20.8099L284.677 21.5401H312.788C330.221 21.5401 344.368 35.6873 344.368 53.1202V184.643L352.4 189.024L342.087 208.1Z",
    fill: "#000"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M114.637 228.271H101.95V239.132H114.637V228.271Z",
    fill: "#000"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M264.049 228.271H251.362V239.132H264.049V228.271Z",
    fill: "#000"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M285.133 20.9012L266.605 9.6748L259.395 21.6314H284.677L285.133 20.9012Z",
    fill: "#000"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M135.173 226.536L153.701 237.763L165.932 217.5H140.65L135.173 226.536Z",
    fill: "#000"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M344.459 185.92C344.459 193.405 341.812 200.25 337.522 205.635L342.086 208.099L352.491 189.115L344.459 184.734V185.92Z",
    fill: "#000"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M204.818 228.75H161.555V239.611H204.818V228.75Z",
    fill: "#000"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M129.149 13.1434L108.065 8.48853L105.236 21.6317H127.324L129.149 13.1434Z",
    fill: "#000"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7905 221.425H83.9695L84.791 217.5H62.612L61.7905 221.425Z",
    fill: "#000"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M204.997 239.132H204.632V261.95H204.997V239.132Z",
    fill: "url(#paint0_linear_1287_3767)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M204.631 239.132H161.368V261.95H204.631V239.132Z",
    fill: "#000"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M264.049 239.132H251.362V261.95H264.049V239.132Z",
    fill: "#000"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M114.637 239.132H101.95V261.95H114.637V239.132Z",
    fill: "#000"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1287_3767",
    x1: 204.8,
    y1: 255.695,
    x2: 204.8,
    y2: 233.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E0B56",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E0B56"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLand);
export default __webpack_public_path__ + "static/media/land.fad58068ce5aae7e786f8c150286e5d6.svg";
export { ForwardRef as ReactComponent };